var slider_crosssell = {
  init: function () {

    console.log("SLIDER CROSSSELL INIT");

    $(window).on('resize', slider_crosssell.resize());
    slider_crosssell.resize();
  },
  resize: function () {
    var _carousel = $(".slider__etape-routine.akrolab");

    if (_carousel.hasClass('slick-initialized')) {
        _carousel.slick('unslick');
    }

    var _slides_to_show = 1;
    var els = document.querySelectorAll(".slider__etape-routine");

    Array.prototype.forEach.call(els, function(el) {
        _slides_to_show = parseInt( window.getComputedStyle(el).getPropertyValue("--nbslide"));
    });

    console.log("INIT SLIDER CROSSSELL : " + _slides_to_show);

    _carousel.slick({
      arrows:true,
      dots:false,
      infinite: true,
      variableWidth:true,
      slidesToShow: _slides_to_show,
      focusOnSelect: true,
      touchThreshold:500,
      prevArrow: _carousel.parent().find(".arrow-container.left"),
      nextArrow: _carousel.parent().find(".arrow-container.right"),
    });
  }
}
$(window).on("load", function () {
  if ($(".akrolab-template .slider__etape-routine").length) {
    slider_crosssell.init();
  }
})
